import { render } from "./DataMapperInvocationAdmin.vue?vue&type=template&id=3c581f63&scoped=true"
import script from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"

import "./DataMapperInvocationAdmin.vue?vue&type=style&index=0&id=3c581f63&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c581f63"]])

export default __exports__